import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import TriggerInputs from './TriggerInputs';

export default function TriggerInputsWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper Component={TriggerInputs} {...props} />
  );
}
